// @flow

import type { IntegrationAction, IntegrationState } from 'stores/flow-type/integration.type';

import {
  INTEGRATION_FAILURE,
  INTEGRATION_SUCCESS,
  INTEGRATION_REQUEST
} from 'stores/flow-type/integration.type';

const initialState: FilesState = {
  loading: false,
  success: false,
  banners: [],
  error: undefined
};

const filesReducers = (state: IntegrationState = initialState, action: IntegrationAction) => {
  switch (action.type) {
    case INTEGRATION_REQUEST:
      return { ...state, loading: true, success: false };
    case INTEGRATION_SUCCESS: {
      const { data } = action.payload;
      return {
        ...state,
        loading: false,
        success: true,
        banners: data,
        error: undefined
      };
    }
    case INTEGRATION_FAILURE: {
      const { data } = action.payload;
      return {
        ...state,
        loading: false,
        success: false,
        banners: data,
        error: action.payload
      };
    }
    default:
      return state;
  }
};
export default filesReducers;
